var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import * as moment from 'moment';
import { feathersServices } from 'src/feathers';
import Avatar from 'antd/lib/avatar';
import 'antd/lib/avatar/style/index.css';
import Icon from 'antd/lib/icon';
import notification from 'antd/lib/notification';
import 'antd/lib/notification/style/index.css';
var Notifications = (function (_super) {
    __extends(Notifications, _super);
    function Notifications(props) {
        var _this = _super.call(this, props) || this;
        _this.trackerNotesRemoved = [];
        _this.handleDeleteNotification = _this.handleDeleteNotification.bind(_this);
        return _this;
    }
    Notifications.prototype.componentWillUnmount = function () {
        clearTimeout(this.timer);
        notification.destroy();
    };
    Notifications.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        var currNotes = this.props.workspaceEvent.notifications;
        var prevNotes = prevProps.workspaceEvent.notifications;
        clearTimeout(this.timer);
        this.timer = window.setTimeout(function () {
            _this.handleNotifications(prevNotes, currNotes);
        }, 0);
    };
    Notifications.prototype.handleNotifications = function (prevNotes, nextNotes) {
        if (!nextNotes || nextNotes.length === 0) {
            notification.destroy();
            return;
        }
        this.handleOpenNotifications(nextNotes);
        if (!prevNotes) {
            return;
        }
        var deletedNotes = prevNotes.filter(function (pN) { return nextNotes.findIndex(function (nN) { return nN.id === pN.id; }) === -1; });
        this.handleCloseNotifications(deletedNotes);
    };
    Notifications.prototype.handleOpenNotifications = function (notes) {
        var _this = this;
        var filteredNotes = notes.filter(function (n) { return _this.trackerNotesRemoved.findIndex(function (id) { return id === n.id; }) === -1; });
        if (notes.length === filteredNotes.length) {
            this.trackerNotesRemoved = [];
        }
        filteredNotes
            .sort(function (a, b) { return a.createdAt && b.createdAt
            ? a.createdAt.localeCompare(b.createdAt)
            : 0; })
            .forEach(function (n) {
            switch (n.type) {
                case 'help-me':
                    notification.open({
                        key: n.id,
                        icon: React.createElement(Avatar, { icon: 'user', src: n.userAvatar }),
                        message: 'Judge needs help!',
                        description: (React.createElement("span", null,
                            React.createElement("strong", null, n.userName),
                            " is calling for help via the judge app.",
                            React.createElement("br", null),
                            React.createElement("small", null,
                                React.createElement("em", null, moment(n.createdAt).fromNow())))),
                        onClose: function () { _this.handleDeleteNotification(n.id); },
                    });
                    break;
                case 'unregistered-bib':
                    notification.warn({
                        key: n.id,
                        icon: React.createElement(Icon, { type: 'warning' }),
                        message: 'Unknown athlete',
                        description: (React.createElement("span", null,
                            n.message,
                            React.createElement("br", null),
                            React.createElement("small", null,
                                React.createElement("em", null, moment(n.createdAt).fromNow())))),
                        onClose: function () { _this.handleDeleteNotification(n.id); },
                    });
                    break;
                default:
                    notification.open({
                        key: n.id,
                        message: 'Notification received',
                        description: 'A notification has been received but our system does not recognizes it. You can probably ignore and delete this.',
                        onClose: function () { _this.handleDeleteNotification(n.id); },
                    });
            }
        });
    };
    Notifications.prototype.handleCloseNotifications = function (notes) {
        notes.forEach(function (n) { return notification.close(n.id); });
    };
    Notifications.prototype.handleDeleteNotification = function (notificationId) {
        this.trackerNotesRemoved.push(notificationId);
        return this.props.dispatch(feathersServices.notifications.remove(notificationId));
    };
    Notifications.prototype.render = function () {
        return null;
    };
    return Notifications;
}(React.Component));
var mapStateToProps = function (state) { return ({
    workspaceEvent: {
        notifications: state.workspaceEvent.notifications && state.workspaceEvent.notifications.data,
    },
}); };
export default connect(mapStateToProps)(Notifications);



//////////////////
// WEBPACK FOOTER
// ./src/pages/components/Notifications/index.tsx
// module id = 726
// module chunks = 0